import classNames from "classnames";
import React from "react";
import { Icon } from "../../graphic/Icon";
import styles from "./Steps.scss";

export const Step = ({ number, current, title, description }) => {
    return (
        <div
            className={classNames(styles.step, {
                [styles.isActive]: number === current,
                [styles.isComplete]: current > number
            })}
        >
            {/* Symbol */}
            <div className={styles.symbol}>
                <span className={styles.number}>{number}</span>
                <Icon size="small" className={styles.icon} name="check" />
            </div>

            {/* Trail */}
            <div className={styles.trail}></div>

            {/* Title */}
            <div className={styles.title}>{title}</div>

            {/* Description */}
            <div className={styles.description}>{description}</div>
        </div>
    );
};
